export default {
  accountConfig: (state) => {
    return state.accountConfig;
  },

  taxTable: (state) => {
    return state.taxTable;
  },

  taxTableById: (state) => {
    return state.taxTableById;
  },

  taxTableIsValid: (state) => {
    return state.taxTableIsValid;
  },

  taxTableLastRecord: (state) => {
    return state.taxTableLastRecord;
  },

  occupationCategory: (state) => {
    return state.occupationCategory;
  },

  occupationCategoryById: (state) => {
    return state.occupationCategoryById;
  },

  occupationCategoryCode: (state) => {
    return state.occupationCategoryCode;
  },

  nationalityType: (state) => {
    return state.nationalityType;
  },

  nationalityTypeById: (state) => {
    return state.nationalityTypeById;
  },

  nationalityTypeCode: (state) => {
    return state.nationalityTypeCode;
  },

  insuranceWorkplace: (state) => {
    return state.insuranceWorkplace;
  },

  insuranceWorkplaceById: (state) => {
    return state.insuranceWorkplaceById;
  },

  insuranceWorkplaceCode: (state) => {
    return state.insuranceWorkplaceCode;
  },

  workPlaceStatus: (state) => {
    return state.workPlaceStatus;
  },

  workPlaceStatusById: (state) => {
    return state.workPlaceStatusById;
  },

  workPlaceStatusCode: (state) => {
    return state.workPlaceStatusCode;
  },

  exemptionType: (state) => {
    return state.exemptionType;
  },

  exemptionTypeById: (state) => {
    return state.exemptionTypeById;
  },

  exemptionTypeCode: (state) => {
    return state.exemptionTypeCode;
  },

  excelSample: (state) => {
    return state.excelSample;
  },

  excelSampleById: (state) => {
    return state.excelSampleById;
  },

  excelSampleMaxColumnIndex: (state) => {
    return state.excelSampleMaxColumnIndex;
  },

  excelSampleDetail: (state) => {
    return state.excelSampleDetail;
  },

  excelSampleId: (state) => {
    return state.excelSampleId;
  },

  excelSampleData: (state) => {
    return state.excelSampleData;
  },

  benefitsAndDeduction: (state) => {
    return state.benefitsAndDeduction;
  },

  benefitsAndDeductionById: (state) => {
    return state.benefitsAndDeductionById;
  },

  benefitsAndDeductionCode: (state) => {
    return state.benefitsAndDeductionCode;
  },

  benefitsAndDeductionPriority: (state) => {
    return state.benefitsAndDeductionPriority;
  },

  insuranceStudio: (state) => {
    return state.insuranceStudio;
  },

  insuranceStudioById: (state) => {
    return state.insuranceStudioById;
  },

  insuranceStudioCode: (state) => {
    return state.insuranceStudioCode;
  },

  settings: (state) => {
    return state.settings;
  },

  employeePortalAccess: (state) => {
    return state.employeePortalAccess;
  },

  workingHours: (state) => {
    return state.workingHours;
  },

  workingHourById: (state) => {
    return state.workingHourById;
  },

  agreementRows: (state) => {
    return state.agreementRows;
  },
  agreementRowById: (state) => {
    return state.agreementRowById;
  },
  agreementRowCode: (state) => {
    return state.agreementRowCode;
  },

  jobGroups: (state) => {
    return state.jobGroups;
  },
  jobGroupById: (state) => {
    return state.jobGroupById;
  },
  jobGroupCode: (state) => {
    return state.jobGroupCode;
  },

  contractTypes: (state) => {
    return state.contractTypes;
  },
  contractTypeById: (state) => {
    return state.contractTypeById;
  },
  contractTypeCode: (state) => {
    return state.contractTypeCode;
  },

  additionalContractParameters: (state) => {
    return state.additionalContractParameters;
  },

  parameterValues: (state) => {
    return state.parameterValues;
  },

  contractSamples: (state) => {
    return state.contractSamples;
  },
  contractSampleById: (state) => {
    return state.contractSampleById;
  },
  contractSampleCode: (state) => {
    return state.contractSampleCode;
  },
  contractSampleId: (state) => {
    return state.contractSampleId;
  },
  contractSampleNavigation: (state) => {
    return state.contractSampleNavigation;
  },

  contracts: (state) => {
    return state.contracts;
  },
  contractById: (state) => {
    return state.contractById;
  },
  contractCode: (state) => {
    return state.contractCode;
  },
  contractId: (state) => {
    return state.contractId;
  },
  contractNavigation: (state) => {
    return state.contractNavigation;
  },

  formulas: (state) => {
    return state.formulas;
  },
  formulaById: (state) => {
    return state.formulaById;
  },
  formulaCode: (state) => {
    return state.formulaCode;
  },
  formulaPriority: (state) => {
    return state.formulaPriority;
  },
  formulaId: (state) => {
    return state.formulaId;
  },

  payrollEmployees: (state) => {
    return state.payrollEmployees;
  },
  payrollEmployee: (state) => {
    return state.payrollEmployee;
  },
  payrollEmployeeContracts: (state) => {
    return state.payrollEmployeeContracts;
  },
  payrollEmployeeVoucher: (state) => {
    return state.payrollEmployeeVoucher;
  },
  payrollEmployeePayment: (state) => {
    return state.payrollEmployeePayment;
  },
  payrollEmployeeDirectVoucher: (state) => {
    return state.payrollEmployeeDirectVoucher;
  },
  payrollEmployeeNavigation: (state) => {
    return state.payrollEmployeeNavigation;
  },
  payrollEmployeeCalculate: (state) => {
    return state.payrollEmployeeCalculate;
  },
  payrollEmployeeImportPreview: (state) => {
    return state.payrollEmployeeImportPreview;
  },

  taxRateTypes: (state) => {
    return state.taxRateTypes;
  },

  printLink: (state) => {
    return state.printLink;
  },

  payrollEmployeeReport: (state) => {
    return state.payrollEmployeeReport;
  },

  employeePayrollSummaryPersonnelReport: (state) => {
    return state.employeePayrollSummaryPersonnelReport;
  },

  employeePayrollSummaryPersonnelDetail: (state) => {
    return state.employeePayrollSummaryPersonnelDetail;
  },

  payrollEmployeeSummaryReport: (state) => {
    return state.payrollEmployeeSummaryReport;
  },

  payrollEmployeeSummaryInsuranceWorkplaceReport: (state) => {
    return state.payrollEmployeeSummaryInsuranceWorkplaceReport;
  },

  advanceReport: (state) => {
    return state.advanceReport;
  },

  payslipReport: (state) => {
    return state.payslipReport;
  },

  insuranceEmployees: (state) => {
    return state.insuranceEmployees;
  },
  insuranceEmployee: (state) => {
    return state.insuranceEmployee;
  },
  insuranceEmployeeId: (state) => {
    return state.insuranceEmployeeId;
  },
  insuranceEmployeeContracts: (state) => {
    return state.insuranceEmployeeContracts;
  },
  insuranceEmployeeNavigation: (state) => {
    return state.insuranceEmployeeNavigation;
  },

  taxEmployees: (state) => {
    return state.taxEmployees;
  },
  taxEmployee: (state) => {
    return state.taxEmployee;
  },
  taxEmployeeId: (state) => {
    return state.taxEmployeeId;
  },
  taxEmployeeContracts: (state) => {
    return state.taxEmployeeContracts;
  },
  taxEmployeeNavigation: (state) => {
    return state.taxEmployeeNavigation;
  },

  leaves: (state) => {
    return state.leaves;
  },
  leaveById: (state) => {
    return state.leaveById;
  },
  leaveCode: (state) => {
    return state.leaveCode;
  },
  leaveNavigation: (state) => {
    return state.leaveNavigation;
  },
  leaveConfirm: (state) => {
    return state.leaveConfirm;
  },
  leaveManagementCartable: (state) => {
    return state.leaveManagementCartable;
  },

  advances: (state) => {
    return state.advances;
  },
  advanceById: (state) => {
    return state.advanceById;
  },
  advanceCode: (state) => {
    return state.advanceCode;
  },
  advanceId: (state) => {
    return state.advanceId;
  },
  advanceNavigation: (state) => {
    return state.advanceNavigation;
  },
  advanceConfirm: (state) => {
    return state.advanceConfirm;
  },
  advanceManagementCartable: (state) => {
    return state.advanceManagementCartable;
  },
  cartableLog: (state) => {
    return state.cartableLog;
  },
  advanceVoucher: (state) => {
    return state.advanceVoucher;
  },
  advanceVoucherId: (state) => {
    return state.advanceVoucherId;
  },
  advanceVoucherNumber: (state) => {
    return state.advanceVoucherNumber;
  },

  bankExportTemplates: (state) => {
    return state.bankExportTemplates;
  },
  bankExportTemplateById: (state) => {
    return state.bankExportTemplateById;
  },
  bankExportTemplateCode: (state) => {
    return state.bankExportTemplateCode;
  },
  bankExportTemplateId: (state) => {
    return state.bankExportTemplateId;
  },
  bankExportTemplateDeleteError: (state) => {
    return state.bankExportTemplateDeleteError;
  },
  bankExportVariables: (state) => {
    return state.bankExportVariables;
  },
  bankExportVariableGroups: (state) => {
    const groups = [];
    state.bankExportVariables.forEach((item) => {
      let group = groups.find((g) => g.title === item.group);
      if (!group) {
        group = { title: item.group || "", items: [] };
        groups.push(group);
      }
      group.items.push(item);
    });
    return groups;
  },
  bankExportPreview: (state) => {
    return state.bankExportPreview;
  },
  bankExportError: (state) => {
    return state.bankExportError;
  },
  bankExportHistory: (state) => {
    return state.bankExportHistory;
  },
  bankExportHistoryDetail: (state) => {
    return state.bankExportHistoryDetail;
  },
  bankExportPayrolls: (state) => {
    return state.bankExportPayrolls;
  },
  bankExportPayrollOptions: (state) => {
    const options = [];
    state.bankExportPayrolls
      .filter((item) => item.isConfirm)
      .forEach((item) => {
        options.push({
          value: item.id,
          text:
            (item.code ? item.code + " - " : "") +
            (item.title ? item.title + " - " : "") +
            item.year +
            "/" +
            String(item.month).padStart(2, "0"),
          year: item.year,
          month: item.month,
          code: item.code,
        });
      });
    return options;
  },
  bankExportTemplateOptions: (state) => {
    const options = [];
    state.bankExportTemplates
      .filter((item) => item.isActive)
      .forEach((item) => {
        options.push({
          value: item.id,
          text: item.title,
          bankKey: item.bankKey,
        });
      });
    return options;
  },

  payroll: (state) => {
    return state.payroll;
  },
};
